module.exports = __webpack_public_path__ + "static/media/whatsapp-square-brands.46e3dd2d.svg";